﻿class CurrencyConversion {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $body: $('body'),
            $marginCalcSearch: $('.margin-calc-search'),
            $transactionCurrency: $(".fx-transaction-currency"),
            $exchangeDate: $(".fx-transaction-date")
        };

        if (this.dom.$marginCalcSearch.length > 0) {
            this.init();
        }
    }

    init() {

        let $dom = this.dom;
        validateIdentityDetails();

        $('label.hide-description').hide();

        $('.currency-calc-btn').on('click', function (e) {
            e.preventDefault();

            if ($('.currency-calc-form').valid()) {

                var currencyConversionInputParam = {
                    "TransactionCurrency": $dom.$transactionCurrency.val(),
                    "ExchangeDate": $dom.$exchangeDate.val()
                };

                GetCurrencyConversionResults(currencyConversionInputParam)
            }
            return false;
        });

        function GetCurrencyConversionResults(currencyConversionInputParam) {

            $('.loading-screen').show();

            let url1 = "/api/sitecore/PSD2/CurrencyConversionData";

            $.ajax({
                url: url1,
                type: 'post',
                data: '{ "transactionCurrency" : "' + currencyConversionInputParam.TransactionCurrency + '","exchangeDate" : "' + currencyConversionInputParam.ExchangeDate + '"}',
                contentType: 'application/json; charset=utf-8',
                cache: false,
                async: true,
                success: function (result) {
                    $('.currency-calc-form').hide();
                    $('.currency-calc-subtitle').hide();
                    $('#CurrencyCalcResult').html(result);
                    $('.currency-calc-results').show();
                },
                complete: function (data) {
                    $('.loading-screen').hide();
                }
            });
        }

        function validateIdentityDetails() {

            var keys = { "keys": ["TRANSACTION_DATE_REQUIRED", "TRANSACTION_DATE_NOT_VALID", "TRANSACTION_DATE_MIN_CHECK", "TRANSACTION_DATE_MAX_CHECK"] };
            getAjaxData("/api/sitecore/validations/GetValidationMessages", "POST", false, keys, function (data) {
                if (data) {
                    $.validator.addMethod('nullCheckTransactionDate', function (value, element) {
                        return value.length > 0;
                    }, data.TRANSACTION_DATE_REQUIRED);


                    $.validator.addMethod('transactionDateMaxCheck', function (value, element) {

                        var transactionDate = $(".fx-transaction-date").val();
                        var returnStatus = true;
                        if (transactionDate != '') {
                            var transactionDateObj = new Date(transactionDate);
                            if (transactionDateObj != 'Invalid Date') {
                                var today = new Date();
                                if (transactionDateObj <= today) {
                                    returnStatus = true;
                                } else {
                                    returnStatus = false;
                                }
                            } else {
                                returnStatus = false;
                            }
                        }
                        return returnStatus;
                    }, data.TRANSACTION_DATE_MAX_CHECK + " " + $(".fx-transaction-date").attr("max"));

                    $.validator.addMethod('transactionDateMinCheck', function (value, element) {

                        var transactionDate = $(".fx-transaction-date").val();
                        var transactionMin = $(".fx-transaction-date").attr("min");
                        var returnStatus = true;
                        if (transactionDate != '') {
                            var transactionDateObj = new Date(transactionDate);
                            var transactionMinDateObj = new Date(transactionMin);
                            if (transactionDateObj != 'Invalid Date') {
                                if (transactionDateObj >= transactionMinDateObj) {
                                    returnStatus = true;
                                }
                                else {
                                    returnStatus = false;
                                }
                            } else {
                                returnStatus = false;
                            }
                        }
                        return returnStatus;
                    }, data.TRANSACTION_DATE_MIN_CHECK + " " + $(".fx-transaction-date").attr("min"));

                    $.validator.addClassRules('fx-transaction-date', { nullCheckTransactionDate: true, transactionDateMaxCheck: true, transactionDateMinCheck: true });
                }
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => new CurrencyConversion());


